export default "__VITE_ASSET__CeqdAQ0R__"